<template>
  <div
    class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
    style="background: #121212"
  >
    <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4 m-4">
      <div class="flex flex-col items-center mb-8">
        <img
          src="/logo.png"
          alt="Palace of Kebap"
          style="width: 80px; height: 80px; border-radius: 50%"
          class="mb-4"
        />
        <h2 style="color: #f5f5f5">Palace of Kebap</h2>
        <p style="color: #999">Admin Dashboard</p>
      </div>
      <vx-card>
        <div class="p-4">
          <vs-input
            name="email"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Email"
            v-model="email"
            class="w-full"
          />
          <vs-input
            type="password"
            name="password"
            icon-no-border
            icon="icon icon-lock"
            icon-pack="feather"
            label-placeholder="Passwort"
            v-model="password"
            class="w-full mt-6"
            @keyup.enter="onLogin"
          />
          <vs-button
            class="w-full mt-8"
            color="primary"
            type="filled"
            @click="onLogin"
            >Anmelden</vs-button
          >
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login",
    }),
    onLogin() {
      this.login({
        email: this.email,
        password: this.password,
      })
        .then(() => {
          this.$router.replace({ name: "orders" });
          this.$vs.notify({
            title: "Willkommen!",
            text: "Erfolgreich angemeldet",
            color: "success",
            position: "top-center",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$vs.notify({
            title: "Fehler",
            text: "Login fehlgeschlagen",
            color: "danger",
            position: "top-center",
          });
        });
    },
  },
};
</script>
